import markdownToHtml from './markdown-to-html';
import DOMPurify from 'dompurify';
import { DOMParser } from '@remirror/pm/model';
import { PlainExtension } from 'remirror';

export class MarkdownPasteExtension extends PlainExtension {
  constructor() {
    super();
  }

  get name() {
    return 'markdownPaste';
  }

  createPlugin() {
    const clipboardTextParser = (inputMarkdown) => {
      const base64ImageRegex = /!\[.*?\]\((data:image\/.*?;base64,.*?)\)/g;
      const base64SanitizedMarkdown = inputMarkdown.replace(base64ImageRegex, '');

      const updatedHtml = markdownToHtml(base64SanitizedMarkdown);
      const wrapper = document.createElement('div');
      wrapper.innerHTML = DOMPurify.sanitize(updatedHtml);
      const domParser = DOMParser.fromSchema(this.store.schema);
      const domSlice = domParser.parseSlice(wrapper);
      return domSlice;
    };

    return {
      props: {
        clipboardTextParser,
      },
    };
  }
}

export default MarkdownPasteExtension;
